import { Search } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControl,
  InputAdornment,
  ListSubheader,
  Menu,
  MenuItem,
  MenuList,
  Modal,
  Select,
  Theme,
  Typography,
} from '@mui/material';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles, useTheme } from '@mui/styles';
import {
  CcfAlert,
  CcfBox,
  CcfButton,
  CcfChatIcon,
  CcfCloseIcon,
  CcfCopyIcon,
  CcfEditPenIcon,
  CcfEmailIcon,
  CcfFacebookIcon,
  CcfFavoriteIcon,
  CcfInstaIcon,
  CcfLinkedinIcon,
  CcfPhoneIcon,
  CcfPopOver,
  CcfSnackBar,
  CcfSupervisorFilterIcon,
  CcfTextField,
  CcfTooltip,
  CcfTrashIcon,
  CcfTypography,
  CcfUpArrowIcon,
  CcfVideoOutlineIcon,
  CcfVoiceMailIcon,
  CcfXIcon,
} from '@nice-ccf/ui-controls';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import StarIcon from '@mui/icons-material/Star';

import styles from '../simulator-v2.module.scss';
import { useEffect, useRef, useState } from 'react';
import FilterStyle from '../utils/filters-styles';
import { useDispatch } from 'react-redux';
import {
  setCreateNewJourney,
  setSelectedChannel,
  setSelectedMedia,
} from '../+state/simulatorV2.slice';
import { useAgentName } from '../utils/useAgentName';
const useStyles = makeStyles({
  textFieldStyle: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      minHeight: '36px',
      width: '360px',
      border: '1px solid #AFC1CE',
    },
  },
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      height: '330px',
      background: '#FFF', // Added background color for DataGrid
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'hidden',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      color: '#333333',
    },
    '& .MuiOutlinedInput-input': {
      padding: '7px',
    },
  },

  appHeaderDivider: {
    height: 'auto',
    borderColor: '#191c21 !important',
    opacity: '1',
    borderBottomWidth: '30px',
  },
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  zIndex: 999,
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
};

export interface PopOverMenuItems {
  items: Array<PopOverMenuItem>;
}

export interface PopOverMenuItem {
  label?: string;
  options: any;
  selectedOption: string;
}

export interface SimulatorV2AllJourneysProps {
  rowData?: any;
  setRowData?: any;
  updatedRowData?: any;
  setUpdatedContact?: any;
  updatedContact?: any;
  isEditClick?: boolean;
  setIsEditClick?: any;
  selectedRowData?: any;
  refreshJourneys?: any;
  setSelectedRowData?: any;
  setUpdatedRowDatav?: any;
  setUpdatedRowData?: any;
  selectedActionItem?: any;
  setSelectedActionItem?: any;
  setupRowData?: any;
  handleIsFavourite?: any;
  handleCloneJourney?: any;
  handleDeleteJourney?: any;
  handleArchiveJourney?: any;
  archivedRowData?: any;
  selectedAction?: any;
  setArchiveRowDataCopy?: any;
  archiveRowDataCopy?: any;
  setArchivedRowData?: any;
}
/**
 * New Simulator Component to mimic the Call/Post feature from different sources
 * * @param props - its will take the list of conatct , current selected conatct and the onclick handler method
 * @returns
 * @example
 */
export function SimulatorV2AllJourneys(props: SimulatorV2AllJourneysProps) {
  const {
    rowData,
    setRowData,
    setUpdatedRowData,
    updatedRowData,
    selectedRowData,
    setSelectedRowData,
    setIsEditClick,
    setUpdatedContact,
    selectedActionItem,
    setSelectedActionItem,
    setupRowData,
    handleIsFavourite,
    handleCloneJourney,
    handleDeleteJourney,
    handleArchiveJourney,
    archivedRowData,
    selectedAction,
    setArchiveRowDataCopy,
    archiveRowDataCopy,
    setArchivedRowData,
  } = props;

  const theme: Theme = useTheme();
  const filterStyles = FilterStyle(theme);
  const dispatch = useDispatch();
  const agentName = useAgentName();

  const filtersDropdownOptions = {
    popOverHeader: 'Filter Options',
    menuItems: [
      {
        items: [
          {
            id: 0,
            label: 'createdBy',
            options: [],
            selectedOption: '',
          },
        ],
      },
    ],
  };
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [searchValue, setSearchValue] = useState('');
  const [rowCreator, setRowCreator] = useState(selectedRowData?.[0]?.createdBy);
  const [isLoading, setIsLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [filterOptions, setFilterOptions]: any = useState(
    filtersDropdownOptions
  );
  const isFirstRender = useRef(true);
  const [showSaveToast, setShowSaveToast] = useState('');
  const [newJourneyName, setNewJourneyName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    clearFilterData();
    setSearchValue('');
  }, []);

  useEffect(() => {
    if (selectedRowData?.[0]?.createdBy) {
      setRowCreator(selectedRowData[0].createdBy);
    }
  }, [selectedRowData]);

  useEffect(() => {
    const updatedOptions = updatedRowData.map((op: any) => op.createdBy);
    const updatedItem = JSON.parse(
      JSON.stringify(filterOptions.menuItems[0]?.items)
    );

    const setOptions = updatedItem.map((res: any, i: any) => ({
      ...res,
      options: [...new Set(updatedOptions)],
    }));
    setFilterOptions((prev: any) => {
      return { ...prev, menuItems: [{ items: setOptions }] };
    });
    if (rowData && rowData.length > 0) {
      setIsLoading(false);
    }
  }, [rowData, updatedRowData]);

  // Dynamically generate dropdownOptions based on the latest selectedRowData and agentName (no useMemo)
  const dropdownOptions = {
    menuItems: [
      {
        items: [
          ...(agentName === rowCreator && !selectedRowData[0]?.isArchived
            ? [
                {
                  label: 'Edit',
                  icon: (
                    <CcfEditPenIcon viewBox="3 0 20 20" fillColor="#3F5C69" />
                  ),
                },
              ]
            : []),

          ...(!selectedRowData[0]?.isArchived
            ? [
                {
                  label: selectedRowData?.[0]?.isFavourites
                    ? 'Remove From Favorites'
                    : 'Add to Favorites',
                  icon: selectedRowData?.[0]?.isFavourites ? (
                    <StarIcon style={{ color: '#FFD700' }} />
                  ) : (
                    <CcfFavoriteIcon style={{ width: 18, color: '#3F5C69' }} />
                  ),
                },
              ]
            : []),

          ...(!selectedRowData[0]?.isArchived
            ? [
                {
                  label: 'Clone',
                  icon: <CcfCopyIcon />,
                },
              ]
            : []),

          ...(agentName === rowCreator
            ? [
                {
                  label: 'Delete',
                  icon: <CcfTrashIcon />,
                },
              ]
            : []),
          ...(agentName === rowCreator
            ? [
                {
                  label: selectedRowData?.[0]?.isArchived
                    ? 'Restore'
                    : 'Archive',
                  icon: !selectedRowData?.[0]?.isArchived ? (
                    <ArchiveOutlinedIcon style={{ color: '#3F5C69' }} />
                  ) : (
                    <UnarchiveIcon style={{ color: '#3F5C69' }} />
                  ),
                },
              ]
            : []),
        ],
      },
    ],
  };

  /**@example */
  const onPopOverItemSelection = (item: PopOverMenuItem) => () => {
    setIsEditClick(false);
    switch (item.label) {
      case 'Add to Favorites':
        setRowData(
          (
            prev: Array<{
              id: string;
              isFavourites: boolean;
              journeyName: string;
            }>
          ) => {
            const updatedRows = prev.map((row) => {
              if (row.id === selectedRowData?.[0]?.id) {
                selectedRowData[0].isFavourites = true;
                dropdownOptions.menuItems[0].items =
                  dropdownOptions.menuItems[0].items.map((item) =>
                    item.label === 'Add to Favorites'
                      ? {
                          ...item,
                          icon: <StarIcon style={{ color: '#FFD700' }} />,
                        }
                      : item
                  );
                handleIsFavourite({
                  ...row,
                  isFavourites: true,
                  itemType: 'add',
                  journeyName: row.journeyName,
                });

                return { ...row, isFavourites: true };
              }
              return row;
            });
            return updatedRows;
          }
        );
        break;
      case 'Remove From Favorites':
        setRowData(
          (
            prev: Array<{
              id: string;
              isFavourites: boolean;
              journeyName: string;
            }>
          ) => {
            return prev.map((row) => {
              if (row.id === selectedRowData?.[0]?.id) {
                handleIsFavourite({
                  ...row,
                  isFavourites: false,
                  itemType: 'remove',
                  journeyName: row.journeyName,
                });
                return { ...row, isFavourites: false };
              }
              return row;
            });
          }
        );
        selectedRowData[0].isFavourites = false;
        break;
      case 'Edit':
        setIsEditClick(true);
        dispatch(setCreateNewJourney(true));
        break;
      case 'Clone':
        handleOpen();
        break;
      case 'Delete':
        handleDialogOpen('delete');
        break;
      case 'Archive':
      case 'Restore':
        handleDialogOpen(item.label.toLowerCase());
        break;
      default:
        break;
    }
    setSelectedActionItem(item.label);
    // setIsEditClick(item.label === 'Edit' ? true : false);
  };
  /**
   * Function to handle drawer open close
   * @example renderIconForType()
   */
  const renderIconForType = (param: string) => {
    switch (param && param.toLowerCase()) {
      case 'voice':
        return (
          <CcfPhoneIcon
            style={{
              fontSize: '15px',
            }}
          />
        );
      case 'videocall':
        return (
          <CcfVideoOutlineIcon
            style={{
              fontSize: '17px',
            }}
          />
        );
      case 'voicemail':
        return (
          <CcfVoiceMailIcon
            style={{
              fontSize: '17px',
            }}
          />
        );
      case 'chat':
        return (
          <CcfChatIcon
            style={{
              fontSize: '20px',
              marginTop: '10px',
            }}
          />
        );
      case 'email':
        return (
          <CcfEmailIcon
            style={{
              fontSize: '15px',
            }}
          />
        );
      case 'x':
        return (
          <CcfXIcon
            style={{
              fontSize: '20px',
            }}
          />
        );
      case 'instagram':
        return (
          <CcfInstaIcon
            style={{
              fontSize: '20px',
            }}
          />
        );
      case 'facebook':
        return (
          <CcfFacebookIcon
            style={{
              fontSize: '20px',
            }}
          />
        );
      case 'linkedin':
        return (
          <CcfLinkedinIcon
            style={{
              fontSize: '20px',
            }}
          />
        );
      default:
        return '';
    }
  };

  const allColumns = [
    {
      field: 'journeyName',
      headerName: 'JOURNEY NAME',
      flex: 1, // reduced from 2
      width: 120, // reduced from 180
      renderCell: (params: any) => (
        <CcfBox className={styles.journeyNameCell}>
          <div style={{ display: 'flex' }}>
            {renderIconForType(
              params.row.media !== 'Digital'
                ? params.row.media
                : params.row.channel
            )}
          </div>
          <CcfTypography
            className={styles.journeyNameText}
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: 'auto', // reduced from 140px
              display: 'block',
              fontSize: '12px',
            }}
            title={params.row.journeyName}
          >
            {params.row.journeyName}
          </CcfTypography>
        </CcfBox>
      ),
      hide: false,
    },
    {
      field: 'journeyDescription',
      headerName: 'DESCRIPTION',
      flex: 1, // reduced from 3
      width: 120, // reduced from 200
      renderCell: (params: any) => (
        <CcfTypography
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 'auto', // reduced from 240px
            display: 'block',
            fontSize: '12px',
          }}
          title={params.row.journeyDescription}
        >
          {params.row.journeyDescription}
        </CcfTypography>
      ),
      hide: false,
    },
    {
      field: 'lastUpdatedDate',
      headerName: 'LAST UPDATED DATE',
      flex: 1,
      width: 120,
      renderCell: (params: any) => (
        <CcfTypography
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 'auto',
            display: 'block',
            fontSize: '12px',
          }}
          title={params.row.lastUpdatedDate}
        >
          {params.row.lastUpdatedDate}
        </CcfTypography>
      ),
      hide: false,
    },
    {
      field: 'createdDate',
      headerName: 'CREATED DATE',
      flex: 1,
      width: 120,
      renderCell: (params: any) => (
        <CcfTypography
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 'auto',
            display: 'block',
            fontSize: '12px',
          }}
          title={params.row.createdDate}
        >
          {params.row.createdDate}
        </CcfTypography>
      ),
      hide: false,
    },
    {
      field: 'createdBy',
      headerName: 'CREATED BY',
      flex: 1,
      width: 120,
      renderCell: (params: any) => (
        <CcfTypography
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 'auto',
            display: 'block',
            fontSize: '12px',
          }}
          title={params.row.createdBy}
        >
          {params.row.createdBy}
        </CcfTypography>
      ),
      hide: false,
    },

    {
      field: '',
      headerName: '',
      flex: 1,
      width: 40,
      renderCell: (params: any) => (
        <div
          style={{
            margin: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
          id="agent_simulatorv2_action_popoverMenu"
        >
          <CcfTooltip title="Start Simulation" placement="left">
            <Button
              onClick={(e: any) => {
                setSelectedActionItem('start simulation');
              }}
            >
              <PlayCircleOutlineOutlinedIcon
                style={{ height: 20, width: 20, color: '#3F5C69' }}
              />
            </Button>
          </CcfTooltip>
          <CcfPopOver
            onPopOverItemSelection={onPopOverItemSelection}
            optionList={dropdownOptions}
            popOverActionIconWrapper={{
              display: 'flex',
              marginRight: '0px',
              minWidth: '20px',
              fontSize: '12px',
            }}
            popOverMain={{ padding: '10px 5px' }}
            popOverActionLabelStyle={styles.popOverActionLabelWrapper}
          />
        </div>
      ),
    },
  ];
  /** 
   @example 
   */
  const handleSave = () => {
    const isDuplicate = [
      ...rowData,
      ...archivedRowData,
    ].some(
      (item: any) =>
        item.journeyName?.replace(/\s+/g, '').toLowerCase() ===
        newJourneyName.replace(/\s+/g, '').toLowerCase()
    );

    if (isDuplicate) {
      setErrorMessage(
        'Journey name already exists in active or archived journeys. Please choose a unique name.'
      );
    } else {
      if (!(newJourneyName.trim() === '') && newJourneyName !== undefined) {
        if (newJourneyName) {
          [...rowData, ...archivedRowData]?.forEach((row: any) => {
            if (
              row.id === selectedRowData?.[0].id &&
              newJourneyName !== undefined
            ) {
              handleCloneJourney(row, newJourneyName);
              setErrorMessage('');
              setIsCloned(false);
            }
          });
        }
      } else {
        setErrorMessage(
          'Journey name cannot be empty or contain only spaces. Please enter a valid name.'
        );
      }
    }
  };

  const [isCloned, setIsCloned] = useState(false);
  const [openDialog, setOpenDialog] = useState('');

  /**@example */
  const handleSearchChange = (event: any) => {
    const searchInputValue = event.target.value;
    if (selectedAction === 'Archived') {
      if (searchInputValue === '') {
        setSearchValue('');
        setArchivedRowData(archiveRowDataCopy);
        clearFilterData();
      } else {
        setSearchValue(searchInputValue);
        const filteredData = archivedRowData.filter((item: any) => {
          return item.journeyName
            .toLowerCase()
            .includes(searchInputValue.toLowerCase());
        });
        setArchivedRowData(filteredData);
      }
    } else {
      if (searchInputValue === '') {
        setSearchValue('');
        setRowData(updatedRowData);
        clearFilterData();
      } else {
        setSearchValue(searchInputValue);
        const filteredData = rowData.filter((item: any) => {
          return item.journeyName
            .toLowerCase()
            .includes(searchInputValue.toLowerCase());
        });
        setRowData(filteredData);
      }
    }
  };

  /**
   * Function to open pop over menu
   * @param event - any
   * @example openPopOverMenu(event)
   */
  const handleChangeFilter = (event: any, i: any) => {
    const updatedItem = JSON.parse(
      JSON.stringify(filterOptions.menuItems[0]?.items)
    );

    let d = Array;

    d = updatedItem.map((x: any) =>
      x.id === i ? { ...x, selectedOption: event.target.value } : x
    );
    setFilterOptions((prev: any) => {
      return { ...prev, menuItems: [{ items: d }] };
    });
  };

  /**
   * handleApplyClick used to  filter data
   * @example <handleApplyClick />
   */
  const handleApplyClick = () => {
    const rd = JSON.parse(JSON.stringify(rowData));
    const opt = JSON.parse(JSON.stringify(filterOptions.menuItems[0].items));

    const selectedOptions = opt.map((x: any) => {
      return x.selectedOption;
    });
    const searchData = updatedRowData.filter((item: any) => {
      return selectedOptions[0] === item.createdBy;
    });
    setRowData(searchData);
    // setAnchorEl(null);
  };

  /**
   * clearFilterData used to clear filter data
   * @example <clearFilterData />
   */
  const clearFilterData = () => {
    setRowData(JSON.parse(JSON.stringify(updatedRowData)));
    const clearData = filterOptions.menuItems[0].items.map((x: any) => ({
      ...x,
      selectedOption: '',
    }));
    setFilterOptions((prev: any) => {
      return { ...prev, menuItems: [{ items: clearData }] };
    });
  };

  /**
   *
   * @example - noDataFound()
   */
  const noRequestFound = () => {
    return (
      <CcfBox className={styles.tableDataContainer}>
        <CcfBox className={styles.noDataFoundBlock}>
          <CcfTypography className={styles.noRequestTxt}>
            No Journeys Found
          </CcfTypography>
        </CcfBox>
      </CcfBox>
    );
  };

  /**
   *
   * @example - handleOpen
   */
  const handleOpen = () => {
    setNewJourneyName('');
    setErrorMessage('');
    setIsCloned(true);
  };
  /**
   *
   * @example - handleClose
   *  This function is used to close the modal and reset the state variables.
   */
  const handleClose = () => {
    setIsCloned(false);
    setNewJourneyName('');
    setErrorMessage('');
  };
  /**
   *
   * @example - handleDialogOpen
   */
  const handleDialogOpen = (type: any) => {
    setOpenDialog(type);
  };

  /**
   *
   * @example - handleDeleteDialogClose
   *  This function is used to close the modal and reset the state variables.
   */
  const handleDialogClose = () => {
    setOpenDialog('');
  };
  /**
   *
   * @example - handleDelete
   *  This function is used to close the modal and reset the state variables.
   */
  const handleDelete = () => {
    const selectedRow = rowData.find(
      (row: { id: string }) => row.id === selectedRowData?.[0]?.id
    );
    if (selectedRow) {
      if (openDialog === 'archive' || openDialog === 'restore') {
        handleArchiveJourney(selectedRow);
      }
      if (openDialog === 'delete') {
        handleDeleteJourney(selectedRow);
      }
    }
    setOpenDialog('');
  };
  /**
   *
   * @example - handleInputChange
   * This function is used to handle the input change event for the new journey name.
   */
  const handleInputChange = (value: any) => {
    const regex = /^(?!\s*$).+/;
    setNewJourneyName(value);
    const trimmedValue = value.trim();
    if (regex.test(trimmedValue)) {
      setErrorMessage('');
    } else {
      setErrorMessage('Enter a valid Journey Name.');
    }
  };
  return (
    <CcfBox ref={isFirstRender}>
      <CcfBox id="allJourneysTableContainer">
        <CcfBox className={styles.tableBlock}>
          <CcfBox className={styles.tableHeader}>
            <CcfBox className={styles.subHeader}>
              <CcfBox className={styles.tableHeaderTextBlock}>
                <CcfTypography
                  id="allJourneysCount"
                  className={styles.tableHeaderText}
                >
                  {rowData.length} items
                </CcfTypography>
              </CcfBox>
              <CcfBox
                id="allJourneysSearchContainer"
                className={styles.searchBoxSection}
              >
                <CcfBox className={styles.searchBox}>
                  <CcfTextField
                    id="allJourneysSearch"
                    size="small"
                    style={{
                      background: 'white',
                    }}
                    className={styles.searchInput}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search htmlColor="grey" />
                        </InputAdornment>
                      ),
                    }}
                    value={searchValue}
                    onChange={(e: any) => {
                      handleSearchChange(e);
                    }}
                    placeholder="Search by Journey Name"
                    variant="outlined"
                    fullWidth
                  />
                </CcfBox>
              </CcfBox>
              {!['Archived', 'Crafted By Me'].includes(selectedAction) && (
                <CcfBox>
                  <Button
                    data-testid="ccf-popover-button"
                    aria-controls="callControlDialog"
                    aria-haspopup="true"
                    className="popOverOverflow"
                    disableRipple
                    sx={{
                      gap: '7px',
                      padding: 0,
                      width: '34px',
                      height: '34px',
                      minWidth: 'auto',
                      border: '1px solid #B0CDDB',
                      '&.MuiButtonBase-root:hover': { bgcolor: 'transparent' },
                    }}
                    onClick={(e: any) => {
                      setAnchorEl(e.currentTarget);
                    }}
                    id="simulatorV2_filters_popOver_button"
                  >
                    <CcfSupervisorFilterIcon
                      fillColor={'#003d7a'}
                      style={{ fontSize: 14 }}
                    />
                  </Button>
                  <Menu
                    id="customizable-columns"
                    MenuListProps={{
                      'aria-labelledby': 'customize-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => setAnchorEl(null)}
                    sx={{
                      '& .MuiMenu-paper': {
                        border: `1px solid ${theme?.palette?.text?.grey}`,
                        width: '336px',
                        left: '191px',
                        '&::-webkit-scrollbar': {
                          width: '0.3rem',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor:
                            theme?.palette?.background?.scrollThumb,
                          borderRadius: '2rem',
                        },
                        '&::-webkit-scrollbar-track': {
                          backgroundColor:
                            theme?.palette?.background?.scrollTrack,
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                          backgroundColor:
                            theme?.palette?.background?.scrollThumbHover,
                        },
                        '& .MuiMenu-list': {
                          paddingTop: 0,
                          paddingBottom: 0,
                        },
                      },
                    }}
                  >
                    <ListSubheader
                      component="div"
                      id="list-subheader"
                      sx={filterStyles.listSubheader}
                    >
                      <CcfTypography sx={filterStyles.customizeText}>
                        Filters
                      </CcfTypography>
                      <CcfCloseIcon
                        viewBox="-8 -4 32 32"
                        sx={filterStyles.closeIcon}
                        data-testid="close-button"
                        onClick={() => setAnchorEl(null)}
                      />
                    </ListSubheader>
                    <div id="filtersPopOver" style={{ width: '336px' }}>
                      {filterOptions.menuItems.map(
                        (parentItem: PopOverMenuItems, index: number) => (
                          <MenuList key={index} style={{ paddingTop: '0px' }}>
                            {parentItem.items?.map(
                              (childItem: PopOverMenuItem, index: number) => (
                                <MenuItem
                                  id={`agent_activeContact_inboxPopOver_${childItem.label}`}
                                  key={index}
                                  className="flexDisplay"
                                  data-testId={`popover-menu-item-${index}`}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    flexDirection: 'column',
                                    paddingBottom: '0px',
                                  }}
                                >
                                  <CcfBox>
                                    <CcfTypography
                                      className={styles.menuHeaderName}
                                    >
                                      {childItem.label?.toUpperCase()}{' '}
                                    </CcfTypography>
                                  </CcfBox>

                                  <FormControl
                                    variant="outlined"
                                    // className={classes.formControl}
                                    size="medium"
                                    style={{
                                      width: '100%',
                                      marginBottom: '0px',
                                    }}
                                    id={`${index}` || 'demo-simple-select'}
                                  >
                                    <Select
                                      labelId="demo-simple-select-label"
                                      variant="outlined"
                                      sx={{
                                        '&& fieldset': {
                                          border: '1px solid #c4c4c4',
                                        },
                                      }}
                                      className={styles.filtersDropdown}
                                      IconComponent={() => (
                                        <CcfUpArrowIcon
                                        // className={classes.arrowIconForDropdown}
                                        />
                                      )}
                                      placeholder="Select"
                                      value={childItem.selectedOption || ''}
                                      onChange={(event: any) => {
                                        handleChangeFilter(event, index);
                                      }}
                                      // className={classes.input}
                                      label={childItem.label}
                                    >
                                      {childItem.options.map(
                                        (option: string, index: number) => {
                                          return (
                                            <MenuItem
                                              value={option}
                                              key={index}
                                              id={`interactionSearch_filtersOptions_${option}`}
                                            >
                                              {option}
                                            </MenuItem>
                                          );
                                        }
                                      )}
                                    </Select>
                                  </FormControl>
                                </MenuItem>
                              )
                            )}
                          </MenuList>
                        )
                      )}
                      <CcfBox className={styles.btnBox}>
                        <CcfButton
                          className={styles.btn}
                          id={`agent_interactionSearch_filters_clear_button`}
                          onClick={() => {
                            clearFilterData();
                          }}
                        >
                          <CcfTypography
                            className={styles.btnText}
                            sx={{ color: '#545cbc' }}
                            // className={`${classes.btnText} ${classes.txtCancel}`}
                          >
                            Clear
                          </CcfTypography>
                        </CcfButton>
                        <CcfButton
                          className={styles.btn}
                          primary
                          // className={`${classes.btn} ${classes.saveButton}`}
                          // disabled={!chatMessage}
                          id={`agent_interactionSearch_filters_apply_button`}
                          onClick={() => {
                            handleApplyClick();
                            setAnchorEl(null);
                          }}
                        >
                          <CcfTypography
                            className={styles.btnText}
                            // className={`${classes.btnText} ${
                            //   chatMessage ? classes.txtSave : classes.txtSaveDisabled
                            // }`}
                          >
                            Apply
                          </CcfTypography>
                        </CcfButton>
                      </CcfBox>
                    </div>
                  </Menu>
                </CcfBox>
              )}
            </CcfBox>
          </CcfBox>

          <CcfBox style={{ height: '70vh', overflowY: 'scroll',border:'1px solid #ebebeb' }}>
            <CcfBox
              style={{
                height: 'inherit',
                backgroundColor: '#FFFF',
                overflowY: 'hidden',
              }}
              id="allJourneysDataGridContainer"
            >
              {' '}
              <DataGrid
                classes={{ root: classes.root }}
                style={{ overflowX: 'hidden' }}
                loading={isLoading}
                rows={
                  rowData && rowData.length > 0
                    ? [...rowData].sort((a, b) => {
                        const dateA = Date.parse(a.lastUpdatedDate);
                        const dateB = Date.parse(b.lastUpdatedDate);
                        return dateB - dateA; // descending order (latest first)
                      })
                    : []
                }
                components={{
                  NoRowsOverlay: () => noRequestFound(),
                }}
                columns={allColumns}
                rowHeight={40}
                getRowId={(row) => row?.id}
                headerHeight={40}
                onSelectionModelChange={(selectedIDs: any) => {
                  const selectedRows = rowData.filter((row: any) =>
                    selectedIDs.includes(row.id)
                  );
                  dispatch(setSelectedMedia(selectedRows[0]?.media));
                  dispatch(setSelectedChannel(selectedRows[0]?.channel));
                  setSelectedRowData(selectedRows);
                  setUpdatedContact({
                    ...selectedRows[0],
                  });
                }}
                pagination
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[10, 20, 50]}
                getRowClassName={(params: any) => `styledrows`}
                sx={{
                  '& .MuiDataGrid-columnHeaderTitle': {
                    color: '#3F5C69',
                    fontWeight: '600',
                    fontSize: '12px',
                    fontFamily: 'Open Sans',
                  },
                }}
                disableColumnFilter={true}
                disableColumnMenu={true}
              />
            </CcfBox>
          </CcfBox>
        </CcfBox>
        {isCloned && (
          <Modal
            open={isCloned}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            slotProps={{
              backdrop: {
                style: {
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  opacity: 0.3,
                },
              },
            }}
          >
            <Box sx={style}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'left',
                  justifyContent: 'space-between',
                  paddingBottom: '0px',
                  gap: '16px',
                }}
              >
                <div
                  style={{ fontWeight: 600, fontSize: '18px' }}
                  id="modal-modal-title"
                  aria-label="modal-modal-title"
                >
                  Clone Journey: {selectedRowData[0]?.journeyName}
                  <div style={{ fontWeight: 400, fontSize: '12px' }}>
                    Required fields are marked with an asterik.
                    <span style={{ color: 'red' }}>*</span>
                  </div>
                </div>
                <CcfBox className={styles.containerGrid}>
                  <CcfTypography style={{ fontWeight: 600, fontSize: '14px' }}>
                    Journey Name <span style={{ color: '#C2041A' }}>*</span>
                  </CcfTypography>
                  <CcfTextField
                    id="journeyName"
                    variant="outlined"
                    className={classes.textFieldStyle}
                    size="small"
                    placeholder={`Clone | ${
                      selectedRowData[0]?.journeyName ?? ''
                    }`}
                    required
                    value={newJourneyName}
                    focused={false}
                    helperText={errorMessage}
                    FormHelperTextProps={{
                      sx: {
                        color: 'red',
                        margin: 0,
                        wordBreak: 'break-word',
                        width: '352px',
                      },
                    }}
                    onChange={(e) => handleInputChange(e.target.value)}
                  />
                </CcfBox>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '16px',
                    marginTop: '0px',
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={handleClose}
                    sx={{ mt: 2 }}
                    style={{
                      backgroundColor: '#fff',
                      border: '1px solid var(--Secondary-Border, #B0CDDB)',
                      color: 'var(--Secondary-Content, #003D7A)',
                      marginTop: '0px',
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSave}
                    sx={{ mt: 2 }}
                    style={{
                      background:
                        ' var(--SOL-Web-Color-Background-Buttons-Primary-Regular, #107DBC)',
                      boxShadow: '0px 1px 3px 0px #00000029',
                      marginTop: '0px',
                    }}
                  >
                    Save
                  </Button>
                </div>
              </Box>
            </Box>
          </Modal>
        )}
        {openDialog && (
          <Modal
            open={openDialog !== ''}
            onClose={handleDialogClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            slotProps={{
              backdrop: {
                style: {
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  opacity: 0.3,
                },
              },
            }}
          >
            <Box sx={style}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'left',
                  justifyContent: 'space-between',
                  paddingBottom: '0px',
                  gap: '16px',
                }}
              >
                <div
                  style={{ fontWeight: 600, fontSize: '18px' }}
                  id="modal-modal-title"
                  aria-label="modal-modal-title"
                >
                  {`Are you sure you want to ${openDialog}
                  ${selectedRowData[0]?.journeyName}?`}
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '16px',
                    marginTop: '0px',
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={handleDialogClose}
                    sx={{ mt: 2 }}
                    style={{
                      backgroundColor: '#fff',
                      border: '1px solid var(--Secondary-Border, #B0CDDB)',
                      color: 'var(--Secondary-Content, #003D7A)',
                      marginTop: '0px',
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleDelete}
                    sx={{ mt: 2 }}
                    style={{
                      background:
                        ' var(--SOL-Web-Color-Background-Buttons-Primary-Regular, #107DBC)',
                      boxShadow: '0px 1px 3px 0px #00000029',
                      marginTop: '0px',
                    }}
                  >
                    Confirm
                  </Button>
                </div>
              </Box>
            </Box>
          </Modal>
        )}
      </CcfBox>
      <CcfBox>
        <CcfSnackBar
          open={showSaveToast !== ''}
          autoHideDuration={3000}
          onClose={() => {
            setShowSaveToast('');
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <div>
            <CcfAlert
              closeAlert={() => {
                setShowSaveToast('');
              }}
              severity="success"
              style={{
                height: 'auto',
                width: 'auto',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {showSaveToast}
            </CcfAlert>
          </div>
        </CcfSnackBar>
      </CcfBox>
    </CcfBox>
  );
}

export default SimulatorV2AllJourneys;
